import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 退回节点")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fc-d" }, null, -1)
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 提 交 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import { reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';

/* Apis */
import { CtRejectApi, GetTurnBackNodesApi } from '@/apis/contract/contract.api';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {


const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	show: false,
	loading: false,
	loadNode: false,
	title: '合同审批',
	detail: {} as any,
	nodeList: [] as any[],
	rules: {
		node_v_id: [{ required: true, message: '请选择退回的节点', trigger: 'blur' }],
		remark: [{ required: true, message: '退回原因不能为空', trigger: 'blur' }],
	} as FormRules,
});

const schema = ref<any>({
	id: '',
	revision: '',
	remark: '',
});

const load = {
	/* 获取可退回的节点列表 */
	getTurnBackNodeList: async (contractId: string) => {
		state.loadNode = true;
		const { succeeded, errors, data } = await GetTurnBackNodesApi(contractId);
		if (succeeded) {
			state.nodeList = data || [];
		} else {
			ElMessage.error(`获取可退回节点失败，可能的原因是：${errors}`)
		}
		state.loadNode = false;
	},
};

const actions = {
	/* 审批通过 */
	save: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;

			state.loading = true;

			const formData = unref(schema);
			const { succeeded, errors } = await CtRejectApi(formData);

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('提交审批成功。');

				$emits('refresh', succeeded);
				state.show = false;
			}

			state.loading = false;
		});
	},

	/* 选择退回的节点 */
	onNodeChange: (val: any) => {
		unref(schema).node_id = `${val.nodeID}`;
		unref(schema).back_empno = val.empno;
	},
};

/* 打开对话框 */
const showDialog = (contract: any) => {
	schema.value = {
		id: contract.contract_id,
		revision: contract.revision,
	};

	load.getTurnBackNodeList(contract.contract_id);

	state.detail = contract;
	state.show = true;
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "批核退回",
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).show) = $event)),
    width: "520"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          disabled: _unref(state).loading,
          onClick: actions.save
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "info",
          disabled: _unref(state).loading,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).show = false))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: schema.value,
          "label-position": "top",
          rules: _unref(state).rules,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "合同编号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.contract_no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.contract_no) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "合同名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.contract_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.contract_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (!schema.value.is_cancel)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "node_v_id"
                }, {
                  label: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"100%"},
                      modelValue: schema.value.node_v_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schema.value.node_v_id) = $event)),
                      "value-key": "id",
                      clearable: "",
                      loading: _unref(state).loadNode,
                      disabled: _unref(state).loadNode,
                      onChange: actions.onNodeChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).nodeList, (node) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: node.id,
                            label: `节点【${node.name}】，人员：${node.empName}(${node.empno})`,
                            value: node
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading", "disabled", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "退回原因",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: schema.value.remark,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schema.value.remark) = $event)),
                  type: "textarea",
                  "show-word-limit": "",
                  rows: "6",
                  maxlength: "150",
                  placeholder: "请输入退回原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})